import { FC } from 'react'
import { Icon } from '@iconify/react'
import {
  Button,
  CompanyLogo,
  IntegratedAccountPill,
  useSEOCountriesJSON,
} from '@pepper/ui'
import { ContentRefreshDomain } from '@pepper/utils/src/types/domain'

import s from './DisconnectConfirmation.module.css'

type Props = {
  connectedDomains?: ContentRefreshDomain[]
  onDisconnect?: () => void
  onCancel?: () => void
}

export const DisconnectConfirmation: FC<Props> = ({
  connectedDomains,
  onDisconnect,
  onCancel,
}) => {
  const { data: countriesJson } = useSEOCountriesJSON()
  return (
    <div className={s.wrapper}>
      <div className={s.iconWrapper}>
        <Icon icon="lucide:alert-triangle" width={24} />
      </div>
      <div className={s.body}>
        <div className={s.header}>
          Are you sure you want to disconnect your account?
        </div>
        {!!connectedDomains?.length && (
          <>
            <div className={s.description}>
              If you remove your current account, the following added domains
              will get affected:
            </div>
            {connectedDomains?.map(domain => (
              <div key={domain.id} className={s.domain}>
                <CompanyLogo
                  companyName={domain.domain_url}
                  className={s.companyLogo}
                />
                {domain.domain_url}
                <img
                  className={s.domainCountryFlag}
                  src={countriesJson?.[domain.country_code]?.flag}
                  alt={domain.country_code}
                />
                <IntegratedAccountPill
                  isIntegrationValid={
                    domain.ga_property.length > 0 &&
                    domain.gsc_domain_property.length > 0
                  }
                  isGoogleConnected={true}
                />
              </div>
            ))}
          </>
        )}

        <div className={s.footer}>
          <Button type="link" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" danger={true} onClick={onDisconnect}>
            Disconnect
          </Button>
        </div>
      </div>
    </div>
  )
}
